import {
    TBForm,
    TBEdit,
    TBEdit2,
    TBDetail,
    getSchemaProp,
    tbBatchUpdateCategory,
    TBDetailSupplier,
    tbGetSchemaProp,
    sizeMappingList,
    sizeMappingSave,
    sizeMappingUpdate,
    sizeMappingDelete,
    tbConfirmPriceStock,
    batchUpdateItemName,
    tbBatchUpdateStock,
    tbBatchUpdateSkuPrice,
} from '@/api/prod/center'

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
      } : {
        ...item,
        skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : [],
        skuDeliveryTime: item.skuDeliveryTime ? `${item.skuDeliveryTime}` : ''
      }
    })
  }

  return isRequest ? {
    ...r,
    // props: JSON.stringify(r.props ? r.props : []),
    // itemImgs: JSON.stringify(r.itemImgs ? r.itemImgs : []),
    // itemRectangleImgs: JSON.stringify(r.itemRectangleImgs ? r.itemRectangleImgs : []),
    // newWirelessDesc: JSON.stringify(r.newWirelessDesc ? r.newWirelessDesc : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    // sizeGroup: JSON.stringify(r.sizeGroup ? r.sizeGroup : {}),
  } : {
    ...r,
    // props: r.props ? JSON.parse(r.props) : [],
    // itemImgs: r.itemImgs ? JSON.parse(r.itemImgs) : [],
    // itemRectangleImgs: r.itemRectangleImgs ? JSON.parse(r.itemRectangleImgs) : [],
    // newWirelessDesc: r.newWirelessDesc ? JSON.parse(r.newWirelessDesc) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    // sizeGroup: r.sizeGroup ? JSON.parse(r.sizeGroup) : {},
    templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
    deliveryTimeType: (!r.deliveryTimeType) ? 0 : r.deliveryTimeType,
    deliveryTimeSetBySku: (!r.deliveryTimeSetBySku && r.deliveryTimeSetBySku !== 0) ? "" : r.deliveryTimeSetBySku,
    tbDeliveryTime: r.tbDeliveryTime || ""
  }
}

/**
 * 获取淘宝商品详情
 * @param {*} params baseitemID
 * @returns 
 */
export const getTbDetail = (params) => {
    return TBDetail(params).then(res => {
        if (res.result === 1 && res.data) {
            return _formatGoodsItem(res.data)
        }
        return []
    })
}
/**
 * 获取淘宝商品详情(供销商小店版)
 * @param {*} params baseitemID
 * @returns 
 */
export const getTbDetailSupplier = (params) => {
    return TBDetailSupplier(params).then(res => {
        if (res.result === 1 && res.data) {
            return _formatGoodsItem(res.data)
        }
        return []
    })
}

/**
 * 编辑保存
 * @param {*} params 
 * @returns 
 */
export function editTbDetail(params) {
    return TBEdit(_formatGoodsItem(params, true)).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}
export function editTbDetail2(data,expandParams) {
    let params = _formatGoodsItem(data, true)
    params = {
      itemInfo:{...params},
      ...expandParams
    }
    return TBEdit2(params).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

/**
 * 获取动态表单
 * @param {*} params 
 * @returns 
 */
export function getForm(params) {
    return TBForm(params).then(res => {
        if (res.result === 1) {
            // if (res.data.saleProp?.children?.length > 2) {
            //   window._globel_vm.$message.error('当前类目为三/四规格类目，暂不支持铺货')
            //   return false
            // }
            // if (!res.data.saleProp?.children?.length) {
            //   window._globel_vm.$message.error('当前类目为无规格类目，暂不支持铺货')
            //   return false
            // }
            // 根据下面逻辑判断是新版的表单还是老版
            // 根据wirelessDesc字段的type是不是为COMPLEX
            res.data._isNew = res.data.wirelessDesc?.type === 'COMPLEX'

            // deliveryTimeSetBySku这个字段目前schema接口不会返回，由我们自己组装
            // 它的规则与tbDeliveryTime字段一致
            if (res.data.tbDeliveryTime) {
              res.data.deliveryTimeSetBySku = {
                label: '按商品规格设置发货时间',
                name: 'deliveryTimeSetBySku',
                type: "SINGLECHECK",
                options: [{
                  dependGroup: null,
                  displayName: "否",
                  value: "0"
                }, {
                  dependGroup: null,
                  displayName: "是",
                  value: "1"
                }]
              }
            }
            // 对3:4图片处理
            if (res.data.threeToFourImages) {
              const { rules = {} } = res.data.threeToFourImages;
              res.data.threeToFourImages.rules = {
                ...rules,
                tipRule: '长图横竖比必须为3：4，最小长度为750, 最多上传5张图片'
              }
            }
            
            return res.data
        } else {
          return false
        }
    }).catch(err => {
      return false
    })
}

/**
 * 【淘宝】商品级联属性信息获取
 * @param {*} params 
 * @returns 
 */
export function getItemPublishSchemaProp(params) {
    return getSchemaProp(params).then(res => {
        if (res.result === 1) {
            return res.data
        }
        return {}
    })
}

/**
 * 【淘宝】商品级联属性信息获取
 * @param {*} params 
 * @returns 
 */
export function getItemPublishSchemaPropV2(params) {
    return tbGetSchemaProp(params).then(res => {
        if (res.result === 1) {
            return res.data || []
        }
        return []
    })
}

// 批量修改类目
export function batchTbCategory(data) {
  return tbBatchUpdateCategory(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
// 获取尺码表模版列表
export function getSizeMappingList(data){
    return sizeMappingList(data).then(res => {
    if (res.result === 1) {
      return res.data || []
    } else {
      return []
    }
  })
}
// 保存尺码表模版
export function saveSizeMapping(data){
    return sizeMappingSave(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
// 更新尺码表模版
export function updateSizeMapping(data){
    return sizeMappingUpdate(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
// 更新尺码表模版
export function deleteSizeMapping(data){
    return sizeMappingDelete(data).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}
export const confirmPriceStock = (data) => {
  return tbConfirmPriceStock({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const batchUpdateName = (data) => {
  return batchUpdateItemName({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const batchUpdateStock = (data) => {
  return tbBatchUpdateStock({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}
export const batchUpdateSkuPrice = (data) => {
  return tbBatchUpdateSkuPrice({data}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}